
import React, { useState } from 'react';
import Button from '../../../components/base/Button';
import SearchModal from '../../../components/feature/SearchModal';

export default function ArticleHero() {
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  return (
    <>
      <section 
        className="relative min-h-[70vh] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.3)), url('/images/article-hero-003.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-left max-w-3xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              旅の<br />
              <span className="bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] bg-clip-text text-transparent">
                インスピレーション
              </span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-4 sm:mb-6 md:mb-8 leading-relaxed">
              世界中の素敵な場所と旅のヒントをお届け
            </p>
            <p className="text-base sm:text-lg text-white/80 mb-6 sm:mb-8 md:mb-10 leading-relaxed">
              SOCIAL TRIPの旅行のプロが厳選した旅行記事で、あなたの次の旅行をさらに思い出深く。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="flex items-center justify-center whitespace-nowrap cursor-pointer"
                onClick={() => setIsSearchModalOpen(true)}
              >
                <i className="ri-search-line mr-3 text-xl"></i>
                旅行記事を探す
              </Button>
            </div>
          </div>
        </div>
      </section>

      <SearchModal 
        isOpen={isSearchModalOpen}
        onClose={() => setIsSearchModalOpen(false)}
      />
    </>
  );
}
